'use client';

import Header from '@/components/common/Header';
import ProductsInteractive from './components/ProductsInteractive';
import FooterWrapper from '@/components/common/FooterWrapper';

export default function ProductsPage() {
  return (
    <>
      <Header />
      <ProductsInteractive />
      <FooterWrapper />
    </>
  );
}